<template>
    <!-- 工作室简介 -->
    <div class="studio">
        <div class="banner">
            <h3 class="subtitle">XXXX中学 </h3>
            <h2 class="title">道德与法治工作室</h2>
            <div class="banner-inner">
                <ul class="menu-list flex-align">
                    <li v-for="(item,index) in menuList" :key="index" class="menu-item csp"
                        :class="{'active-menu':activeMenu == index}" @click="chooseMenu(index)">
                        {{item.title}}
                    </li>
                </ul>
            </div>
        </div>
        <div class="studio-main">
            <div class="main-inner flex-layout">
                <div class="studio-sidebar">
                    <img src="../../assets/studio/image-1.png" alt="" class="avatar">
                    <p class="expert-name">王海燕</p>
                    <ul class="info-list flex-layout">
                        <li v-for="(item,index) in infoList" :key="index" class="info-item">
                            <img :src="item.icon" alt="">
                            <p class="info-text">{{item.text}}</p>
                        </li>
                    </ul>
                    <ul class="contact-list">
                        <li v-for="(item,index) in contactList" :key="index" class="contac-item">
                            <img :src="item.icon" alt="" class="contac-icon">
                            <span>{{item.text}}</span>
                        </li>
                    </ul>
                </div>
                <router-view class="studio-view"></router-view>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                activeMenu: 0,
                menuList: [{
                        title: '工作室首页',
                        herf: 'studioIntroduce'
                    },
                    {
                        title: '主持人简介',
                        herf: 'hostIntroduce'
                    },
                    {
                        title: '团队成员',
                        herf: 'member'
                    },
                    {
                        title: '特色项目',
                        herf: 'project'
                    },
                    {
                        title: '专项课程',
                        herf: 'course'
                    }
                ],
                infoList: [{
                    icon: require("../../assets/studio/icon-10.png"),
                    text: '北京市'
                }, {
                    icon: require("../../assets/studio/icon-11.png"),
                    text: '道德与法治'
                }, {
                    icon: require("../../assets/studio/icon-12.png"),
                    text: '高中教育'
                }],
                contactList: [{
                    icon: require("../../assets/studio/icon-7.png"),
                    text: '010-556199959'
                }, {
                    icon: require("../../assets/studio/icon-8.png"),
                    text: 'presscip@sina.com'
                }, {
                    icon: require("../../assets/studio/icon-9.png"),
                    text: '北京市昌平区科技园区超前路3号'
                }]
            }
        },
        methods: {
            chooseMenu(index) {
                this.activeMenu = index;
                this.$router.push(`${this.menuList[index].herf}`)
            },
        },
        mounted() {
            this.menuList.map((item, index) => {
                if (item.herf == this.$route.name) {
                    this.activeMenu = index;
                }
            })
        },
    }
</script>

<style lang="less" scoped>
    .studio {
        .banner {
            background-image: url("../../assets/studio/detail_banner.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            height: 56vh;
            max-height: 530px;
            min-height: 360px;
            padding-left: 6.9%;
            position: relative;

            .subtitle,
            .title {
                color: #fff;
                text-shadow: 5px 5px #2B2035;
                letter-spacing: 10px;
                position: absolute;

            }

            .subtitle {
                font-size: 50px;
                margin-right: 22%;
                margin-bottom: 1%;
                left: 30%;
                top: 26%;
            }

            .title {
                font-size: 63px;
                margin-bottom: 2.5%;
                font-weight: bold;
                top: 40%;
                left: 49%;
                transform: translateX(-50%);
            }

            .banner-inner {
                position: absolute;
                width: 100%;
                bottom: 11%;
            }

            .menu-list {
                padding-right: 40%;
            }

            .menu-item {
                color: #fff;
                font-size: 30px;
                // margin-bottom: 7.3%;
                letter-spacing: 2px;
                position: relative;
                width: 20%;
                font-weight: 300;

                &.active-menu {
                    font-weight: 400;
                }

                &.active-menu::before {
                    position: absolute;
                    content: " ";
                    width: 23px;
                    height: 8px;
                    top: 50%;
                    transform: translateY(-50%);
                    left: -33px;
                    background-image: url("../../assets/business/arrow.png");
                }

                &:nth-child(2) {
                    width: 20%;
                }
            }
        }

        .studio-main {
            padding: 5.8% 0 50%;
        }

        .main-inner {
            padding: 0 5.2% 50%;
            background-image: url("../../assets/studio/studio-bg.png");
            background-repeat: no-repeat;
            background-position: center;
            // width: 100%;
        }

        .studio-sidebar {
            flex-shrink: 0;
            background-image: url("../../assets/studio/sidebar.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            width: 30%;
            min-width: 350px;
            height: 94.5vh;
            min-height: 500px;
            max-height: 888px;
            text-align: center;
            position: relative;
            margin-right: 4%;

            .avatar {
                width: 63%;
                height: 36.5%;
                border-radius: 50%;
                border: 10px solid #fff;
                display: inline-block;
                margin-top: 13%;
            }


            .expert-name {
                color: #fff;
                font-size: 34px;
                font-weight: bold;
                padding-top: 4.3%;
                letter-spacing: 3px;
            }

            .info-list {
                padding: 0 15px;
                margin-top: 6.3%;

                .info-item {
                    border-right: 1px solid #0068b7;
                    color: #fff;
                    font-size: 18px;
                    width: calc(100% / 3);

                    &:nth-child(2) {
                        .info-text {
                            margin-top: 12%;
                        }
                    }

                    &:last-child {
                        border-right: 0;

                        .info-text {
                            margin-top: 16.5%;
                        }
                    }
                }



                .info-text {
                    margin-top: 8%;

                }
            }

            .contact-list {
                position: absolute;
                bottom: 7%;
                color: #fff;
                text-align: left;
                font-size: 16px;
                width: 100%;
                padding-left: 24.3%;

                .contac-item {
                    margin-bottom: 3.5%;

                    &:nth-child(3) {
                        margin-left: 3px;
                    }
                }

                .contac-icon {
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: 4.4%;
                }
            }

        }

        .studio-view {
            width: 100%;
        }

        @media screen and (max-width:1850px) {
            .banner {
                .title {
                    font-size: 40px;
                }

                .menu-item {
                    font-size: 25px;
                }
            }
        }

        @media screen and (max-width:1450px) {
            .banner {
                // height: 530px;

                .title {
                    font-size: 31px;
                }

                .menu-item {
                    font-size: 20px;
                }
            }

        }

        @media screen and (max-width:1150px) {
            .banner {
                .title {
                    font-size: 25px;
                }

                .menu-item {
                    font-size: 16px;
                }
            }
        }
    }
</style>